// extracted by mini-css-extract-plugin
module.exports = {"extLink":"ext-link-module--extLink--2MgqI","linkIcon":"ext-link-module--linkIcon--2b4Bs","linkLabel":"ext-link-module--linkLabel--X6spk"};